import { render } from "./ProjectsNotice.vue?vue&type=template&id=4f9f58be"
import script from "./ProjectsNotice.vue?vue&type=script&lang=js"
export * from "./ProjectsNotice.vue?vue&type=script&lang=js"

import "./ProjectsNotice.vue?vue&type=style&index=0&id=4f9f58be&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__